<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${paymentTerm.name}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="paymentTerm" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "payment-term-view-logs",

  components: { LogListTable },

  props: ["paymentTerm"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    paymentTerm(paymentTerm) {},
  },
};
</script>
